import { Injectable, NgZone } from '@angular/core';
import { CommonService } from './common.service';
import { UtilService } from 'src/app/core/services/util.service';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private readonly timeoutDuration = 5 * 60 * 60 * 1000; // 5 hours in milliseconds
  // private readonly timeoutDuration = 5 * 1000; // 10 sec in milliseconds

  constructor(
    private readonly ngZone: NgZone,
    private readonly commonService: CommonService,
    private readonly utilService: UtilService
  ) {}

  startWatching() {
    const lastActive = localStorage.getItem('lastActiveTime');
    if (!lastActive) {
      // Save the initial timestamp
      this.updateLastActiveTime();
    }

    // Add event listeners to monitor user interaction
    window.addEventListener('click', this.handleUserInteraction);
    this.handleUserInteraction();
  }

  private readonly updateLastActiveTime = () => {
    const currentTime = Date.now();
    localStorage.setItem('lastActiveTime', currentTime.toString());
  };

  private readonly handleUserInteraction = () => {
    const lastActiveTime = parseInt(
      localStorage.getItem('lastActiveTime') ?? '0',
      10
    );
    const currentTime = Date.now();

    if (currentTime - lastActiveTime > this.timeoutDuration) {
      this.logout();
    } else {
      // Reset the activity timer if the user is still active
      this.updateLastActiveTime();
    }
  };

  private logout() {
    const consentPending = localStorage.getItem('CONSENT_PENDING') === 'true';

    if (consentPending) {
      return;
    }
    this.ngZone.run(() => {
      localStorage.removeItem('lastActiveTime');
      if (this.commonService.getAccessToken()) {
        this.utilService.logoutApi().subscribe(() => {
          this.commonService.clearLocalStorageItems();
          this.utilService.redirectToLogin();
        });
      } else {
        this.commonService.clearLocalStorageItems();
        this.utilService.redirectToLogin();
      }
    });
  }

  stopWatching() {
    window.removeEventListener('click', this.handleUserInteraction);
  }
}
